import { usePlayerActions } from "@utils/player/core/usePlayer";
import LBox from "@components/LBox";
import { TracksSWM } from "@components/QueueManager/TracksSWM";
import { useCallback, useEffect, useRef, useState } from "react";

import { usePlayerControls } from "@utils/player";
import { selectActiveQueueItemId } from "@utils/player/core/selectors";
import { usePlayer } from "@utils/player/core/usePlayer";

export const QueueListSWM = ({
  activeSetListExpanded,
  closeModal,
  selectedSongQueueIds,
  selectSongQueueId,
}: {
  activeSetListExpanded: boolean;
  closeModal: () => void;
  selectedSongQueueIds: string[];
  selectSongQueueId: (songQueueId: string) => void;
}) => {
  const playerActions = usePlayerActions();

  const activeQueueItemId = usePlayer(selectActiveQueueItemId);
  const playFromQueueItem = playerActions.playFromQueueItem;
  const { startSeek, endSeek } = usePlayerControls();

  const [pendingSeek, setPendingSeek] = useState<{
    songQueueId: string;
    startSeconds: number;
  } | null>(null);

  const handledSeekRef = useRef<string | null>(null);
  useEffect(() => {
    if (!pendingSeek || activeQueueItemId !== pendingSeek.songQueueId) return;
    if (handledSeekRef.current === pendingSeek.songQueueId) return;

    handledSeekRef.current = pendingSeek.songQueueId;
    startSeek();
    endSeek(pendingSeek.startSeconds)
      .catch(console.error)
      .finally(() => {
        handledSeekRef.current = null;
        setPendingSeek(null);
      });
  }, [activeQueueItemId, endSeek, pendingSeek, startSeek]);

  const handleSetListEntryPress = useCallback(
    (songQueueId: string, startSeconds: number) => {
      if (activeQueueItemId === songQueueId) {
        startSeek();
        endSeek(startSeconds).catch(console.error);
      } else {
        playFromQueueItem(songQueueId, { autoPlay: true });
        setPendingSeek({ songQueueId, startSeconds });
      }
    },
    [activeQueueItemId, endSeek, playFromQueueItem, startSeek],
  );

  return (
    <LBox flex={1}>
      <TracksSWM
        activeSetListExpanded={activeSetListExpanded}
        closeModal={closeModal}
        onSetListEntryPress={handleSetListEntryPress}
        selectSongQueueId={selectSongQueueId}
        selectedSongQueueIds={selectedSongQueueIds}
      />
    </LBox>
  );
};
